import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Avatar from '../../../components/Avatar';
import { LPTitle, LPText } from '../../styles';

import { HeroWrapper, SectionWrapper } from '../../BookingPage/styles';

const UserInfoHeader = ({
  avatarImg,
  firstName,
  lastName,
  description,
  extraText,
  isVerified,
  children,
  sticky,
  progress,
}) => (
  <HeroWrapper sticky={sticky} progress={progress}>
    <Avatar
      small
      user={{
        firstName,
        lastName,
      }}
      imageUrl={avatarImg}
    />

    <SectionWrapper padded progress={progress}>
      <LPTitle nomargin large upcase>
        <span className="thin">{firstName}</span>
        {lastName}
        {isVerified && <img src="/images/verifiedCheckIcon.png" alt="" />}
      </LPTitle>
      <LPText nomargin small>
        {description}
      </LPText>
      {extraText !== '' && <LPText w400>{extraText}</LPText>}
      {children}
    </SectionWrapper>
  </HeroWrapper>
);

UserInfoHeader.defaultProps = {
  avatarImg: '',
  firstName: '',
  lastName: '',
  description: '',
  extraText: '',
  isVerified: false,
  sticky: false,
  progress: 0,
  children: <></>,
};

UserInfoHeader.propTypes = {
  avatarImg: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  description: PropTypes.string,
  extraText: PropTypes.string,
  isVerified: PropTypes.bool,
  sticky: PropTypes.bool,
  progress: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default memo(UserInfoHeader);
